const SET_PDF_URL = 'SET_PDF_URL'
const SET_MODAL_IMPRESSAO_ESTA_FECHADO = 'SET_MODAL_IMPRESSAO_ESTA_FECHADO'
const SET_RECUSAR_IMPRESSAO_RECIBO_DE_SERVICO = 'SET_RECUSAR_IMPRESSAO_RECIBO_DE_SERVICO'

export default {
  namespaced: true,
  state: {
    pdfUrl: null,
    modalImpressaoEstaFechado: false,
    recusarImpressaoReciboDeServico: false
  },
  getters: {
    getPdfUrl: state => state.pdfUrl,
    getModalImpressaoEstaFechado: state => state.modalImpressaoEstaFechado,
    getRecusarImpressaoReciboDeServico: state => state.recusarImpressaoReciboDeServico,
  },
  mutations: {
    [SET_PDF_URL] (state, data) {
      state.pdfUrl = data
    },
    [SET_MODAL_IMPRESSAO_ESTA_FECHADO] (state, data) {
      state.modalImpressaoEstaFechado = data
    },
    [SET_RECUSAR_IMPRESSAO_RECIBO_DE_SERVICO] (state, data) {
      state.recusarImpressaoReciboDeServico = state.recusarImpressaoReciboDeServico !== data ? data : !data
    }
  },
  actions: {
    setPdfUrl ({ commit }, data) {
        commit(SET_PDF_URL, data)
    },
    setModalImpressaoEstaFechado ({ commit }, data) {
        commit(SET_MODAL_IMPRESSAO_ESTA_FECHADO, data)
    },
    setRecusarImpressaoReciboDeServico ({ commit }, data) {
        commit(SET_RECUSAR_IMPRESSAO_RECIBO_DE_SERVICO, data)
    }
  }
}